import React from "react";
import CartFunnelEmailCampaign from "../../../components/Pages/Campaign/CartFunnel/Email";

const CartFunnelEmail = () => {
  return (
    <div>
      <CartFunnelEmailCampaign />
    </div>
  );
};

export default CartFunnelEmail;
